import * as ReactDOM from 'react-dom/client';
import { WebComponent, UIRuntimeBuilder } from '@cian/mf-registry/browser';
import { IApplicationContext } from 'shared/types/applicationContext';
import { TReduxStore } from 'shared/types/redux';
import { Application } from 'shared/containers/App';
import { RUNTIME_NAME } from 'shared/constants/constants';

export const createMicrofrontendUI = (context: IApplicationContext, store: TReduxStore) => (): UIRuntimeBuilder => {
  class SearchString extends WebComponent {
    public constructor() {
      super();
    }
    private disconnectTimerId: ReturnType<typeof setTimeout> | null = null;
    private root: ReactDOM.Root | null = null;
    protected microfrontendName = context.config.getStrict<string>('projectName');
    protected imageVersion = context.config.getStrict<string>('version.commit');
    protected runtimeName = RUNTIME_NAME;

    public async connectedCallback() {
      if (this.disconnectTimerId) {
        clearTimeout(this.disconnectTimerId);
        this.disconnectTimerId = null;
      }

      await super.connectedCallback();
    }

    public disconnectedCallback() {
      if (this.disconnectTimerId) {
        clearTimeout(this.disconnectTimerId);
      }

      this.disconnectTimerId = setTimeout(() => {
        if (this.isConnected) {
          this.disconnectTimerId = null;

          return;
        }

        this.root?.unmount();
        this.root = null;
        super.disconnectedCallback();
        this.disconnectTimerId = null;
      }, 0);
    }

    public async render() {
      const reactElement = <Application {...this.props} context={context} reduxStore={store} />;

      if (!this.root) {
        if (this.shouldHydrate) {
          this.root = ReactDOM.hydrateRoot(this, reactElement);
        } else {
          this.root = ReactDOM.createRoot(this);
          this.root.render(reactElement);
        }
      } else {
        this.root.render(reactElement);
      }
    }
  }

  return { customElementConstructor: SearchString };
};
